module.exports = __webpack_public_path__ + "static/mutual-aid-hub-1fc6846d6cad2200a5551e9f4c4d752e.png";